/**
 * Non-gating warnings surfaced by the 1-Klick slot search (PRD #928 / RS-007).
 * Emitted on `FindEarliestSlotsResponseDto.warnings` so the UI can advise the
 * scheduler without blocking the result.
 *
 * - `SCATTERED_ACROSS_THERAPISTS` — the chosen objective (currently only
 *   `PREFER_ONE_THERAPIST`) could not place all requested slots on a single
 *   therapist, so the search fell back to the fewest-therapists assembly. The
 *   accompanying `therapistCount` tells the UI across how many distinct
 *   therapists the series is spread.
 */
export var SlotSearchWarningCode;
(function (SlotSearchWarningCode) {
    SlotSearchWarningCode["SCATTERED_ACROSS_THERAPISTS"] = "SCATTERED_ACROSS_THERAPISTS";
})(SlotSearchWarningCode || (SlotSearchWarningCode = {}));
//# sourceMappingURL=slot-search-warning-code.enum.js.map